// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sparkline-container{display:flex;flex-wrap:wrap;padding-bottom:60px}.sparkline{width:280px;max-width:280px;border-radius:8px;padding:8px 16px;margin:8px;border:1px solid #ececec}.sparkline .highcharts-background{fill:transparent}.sparkline-container--long-lines .sparkline__title{min-height:60px!important}.sparkline__title{position:relative}.sparkline__title .m-chart__units{position:absolute;margin-left:0!important;padding:0;bottom:0}", ""]);
// Exports
module.exports = exports;
